// import React, { useState, useMemo } from "react";
// import Select, { SingleValue } from "react-select";
// import DataTable, { TableColumn } from "react-data-table-component";
// //import axios from "axios";
// import { apiAxios } from "../../../../utils/apiAxios";
// import { OptionType } from "../Interfaces/OptionType";
// import { ApiResponse, OrderRow } from "../Interfaces/OrderRow";
// const API_BASE = process.env.REACT_APP_API_BASE_URL;
// /* ================= OPTIONS ================= */

// const designerOptions: OptionType[] = [
//   { value: "", label: "All" },

//   { value: "Designer not assigned yet", label: "Designer not assigned yet" },
//   { value: "Re-upload Scan", label: "Re-upload Scan" },
//   { value: "Scan Rejected", label: "Scan Rejected" },
//   { value: "Acceptance Overdue", label: "Acceptance Overdue" },
//   { value: "To be Accepted", label: "To be Accepted" },
//   { value: "In Design", label: "In Design" },
//   { value: "Design Overdue", label: "Design Overdue" },
//   { value: "Delay Report", label: "Delay Report" },
//   { value: "Waiting for Design", label: "Waiting for Design" },
//   { value: "Done", label: "Done" },
//   { value: "Assigned", label: "Assigned" },
//   { value: "--", label: "--" },
//   { value: "Completed", label: "Completed" },
//   { value: "Cancelled", label: "Cancelled" },
// ];

// const millingOptions: OptionType[] = [
//   { value: "", label: "All" },

//   { value: "Milling not assigned yet",label: "Milling not assigned yet"},
//   {value: "Cancelled",label: "Cancelled"},
//   {value: "Acceptance Overdue",label: "Acceptance Overdue"},
//   { value: "To be Accepted",label: "To be Accepted"},
//   { value: "Waiting for Design",label: "Waiting for Design" },
//   {value: "Start Milling", label: "Start Milling" },
//   {value: "Delay Report",label: "Delay Report"},
//   {value: "In Milling",label: "In Milling"},
//   {value: "Done",label: "Done"},
//   { value: "Out for Delivery",label: "Out for Delivery"},
//   { value: "Scan Rejected",label: "Scan Rejected" },
//   { value: "—",label: "—"}
// ];

// const deliveryOptions: OptionType[] = [
//   { value: "", label: "All" },
//   { value: "Cancelled",label: "Cancelled"},
//   {value: "Assigned", label: "Assigned" },
//   { value: "Ready for Dispatch",label: "Ready for Dispatch" },
//   { value: "Out for Delivery",label: "Out for Delivery" },
//   { value: "Done", label: "Done" }
// ];

// const getStatusStyle = (status: string) => {
//   switch (status?.toLowerCase()) {
    

//     case "needs attention":
//       return { border: "1px solid #E35D6A" , background:"#F8D7DA", color: "#000" };

//     case "awaiting response":
//       return { background: "#f97316", color: "#fff" };

//     case "scan rejected":
//     case "milling hub rejected":
//       return { background: "#991b1b", color: "#fff" };

//     case "design delay":
//     case "milling overdue":
//       return { background: "#b45309", color: "#fff" };

//     case "on time":
//       return {  border: "1px solid #dedada", background: "#fff", color: "#000",  };

//     case "start milling":
//       return { background: "#2563eb", color: "#fff" };

//     case "waiting for design":
//       return { background: "#f59e0b", color: "#000" };

//     case "in milling":
//       return { background: "#ffcd39", color: "#000" };

//     case "done":
//     case "completed":
//       return { background: "#16a34a", color: "#fff" };

//     default:
//       return { background: "#6b7280", color: "#fff" };
//   }
// };

// /* ================= COMPONENT ================= */

// const OrderSearchPage: React.FC = () => {
//   const [designerStatus, setDesignerStatus] = useState<OptionType | null>(null);
//   const [millingStatus, setMillingStatus] = useState<OptionType | null>(null);
//   const [deliveryStatus, setDeliveryStatus] = useState<OptionType | null>(null);

//   const [data, setData] = useState<OrderRow[]>([]);
//   const [loading, setLoading] = useState<boolean>(false);

//   /* ================= TABLE COLUMNS ================= */

// const columns: TableColumn<OrderRow>[] = useMemo(() => [
//   { name: "Order ID",   width: "100px", selector: row => row.orderID, sortable: true },
//   { name: "Patient",   width: "140px", selector: row => row.patientName, sortable: true },

//   { 
//     name: "Designer", 
//     sortable: true,
//         width: "190px",
//     cell: row => <span title={row.designerStatus}>{row.designerStatus}</span>
//   },
//   { 
//     name: "Milling", 
//         width: "280px",
//     sortable: true,
//     cell: row => <span title={row.millingStatus}>{row.millingStatus}</span>
//   },
//   { 
//     name: "Delivery", 
//     width: "220px",
//     cell: row => <span title={row.deliveryStatus}>{row.deliveryStatus}</span>
//   },

//   {
//     name: "Manager",
//           width: "180px",
//     cell: row => (
//       <span style={{
//         ...getStatusStyle(row.managerState),
//         padding: "4px 8px",
//         borderRadius: "5px",
//         fontSize: "13px",
//         width: "120px",
//         display: "inline-block",
//         textAlign: "center"
//       }}>
//         {row.managerState}
//       </span>
//     )
//   },
// ], []);

//   /* ================= STATUS COLOR ================= */

//   const getStatusColor = (status: string): string => {
//     if (!status) return "gray";

//     if (status.includes("ATTENTION")) return "red";
//     if (status.includes("COMPLETED")) return "green";
//     if (status.includes("PENDING")) return "orange";

//     return "blue";
//   };

//   /* ================= API CALL ================= */

//   const handleSearch = async (): Promise<void> => {
//     setLoading(true);

//     try {
//       const res = await apiAxios.post<ApiResponse>(`${API_BASE}/Central/search-cases`, {
//         designerStatus: designerStatus?.value || null,
//         millingStatus: millingStatus?.value || null,
//         deliveryStatus: deliveryStatus?.value || null,
//       });

//       setData(res.data.dataOne);
//     } catch (err) {
//       console.error("Search Error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ================= UI ================= */

//   return (
//     <div className="container">

//       <h5 className="mb-4 order-search-panel">Order Search Panel</h5>
// <div className="premium-card mt-2">
//      <div className="row g-3 align-items-end">

//   {/* Designer */}
//   <div className="col-md-4">
//     <label className="form-label">Designer Status</label>
//     <Select
//       options={designerOptions}
//       onChange={(val) => setDesignerStatus(val)}
//       placeholder="Select Designer Status"
//       isClearable
//     />
//   </div>

//   {/* Milling */}
//   <div className="col-md-4">
//     <label className="form-label">Milling Status</label>
//     <Select
//       options={millingOptions}
//       onChange={(val) => setMillingStatus(val)}
//       placeholder="Select Milling Status"
//       isClearable
//     />
//   </div>

//   {/* Delivery */}
//   <div className="col-md-4">
//     <label className="form-label">Delivery Status</label>
//     <Select
//       options={deliveryOptions}
//       onChange={(val) => setDeliveryStatus(val)}
//       placeholder="Select Delivery Status"
//       isClearable
//     />
//   </div>

//   {/* Button FIXED */}
//   <div className="col-md-2 mt-3">
//     <button
//       className="btn btn-primary"
//       onClick={handleSearch}
//     >
//        Search
//     </button>
//   </div>

// </div>
// </div>
// <div className="premium-card mt-5">
//       <DataTable
//         columns={columns}
//         data={data}
//         progressPending={loading}
//         pagination
//         highlightOnHover
//         striped
//       />
// </div>
//     </div>
//   );
// };

// export default OrderSearchPage;
import React, { useState, useMemo, useEffect } from "react";
import Select from "react-select";
import DataTable, { TableColumn } from "react-data-table-component";

import { apiAxios } from "../../../../utils/apiAxios";
import { OptionType } from "../Interfaces/OptionType";
import { ApiResponse, OrderRow } from "../Interfaces/OrderRow";

import "../../../../style/custommillingHubdashboard.css";
import "../../../../style/customresponsivefile.css";


const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

/* =========================================================
   DESIGNER STATUS OPTIONS
========================================================= */

const designerOptions: OptionType[] = [
  { value: "", label: "All" },

  {
    value: "Designer not assigned yet",
    label: "Designer not assigned yet"
  },
  {
    value: "Re-upload Scan",
    label: "Re-upload Scan"
  },
  {
    value: "Scan Rejected",
    label: "Scan Rejected"
  },
  {
    value: "Acceptance Overdue",
    label: "Acceptance Overdue"
  },
  {
    value: "To be Accepted",
    label: "To be Accepted"
  },
  {
    value: "In Design",
    label: "In Design"
  },
  {
    value: "Design Overdue",
    label: "Design Overdue"
  },
  {
    value: "Delay Report",
    label: "Delay Report"
  },
  {
    value: "Waiting for Design",
    label: "Waiting for Design"
  },
  {
    value: "Done",
    label: "Done"
  },
  {
    value: "Assigned",
    label: "Assigned"
  },
  // {
  //   value: "--",
  //   label: "--"
  // },
  {
    value: "Completed",
    label: "Completed"
  },
  {
    value: "Cancelled",
    label: "Cancelled"
  }
];


/* =========================================================
   MILLING STATUS OPTIONS
========================================================= */

const millingOptions: OptionType[] = [
  { value: "", label: "All" },

  {
    value: "Milling not assigned yet",
    label: "Milling not assigned yet"
  },
  {
    value: "Cancelled",
    label: "Cancelled"
  },
  {
    value: "Acceptance Overdue",
    label: "Acceptance Overdue"
  },
  {
    value: "To be Accepted",
    label: "To be Accepted"
  },
  {
    value: "Waiting for Design",
    label: "Waiting for Design"
  },
  {
    value: "Start Milling",
    label: "Start Milling"
  },
  {
    value: "Delay Report",
    label: "Delay Report"
  },
  {
    value: "In Milling",
    label: "In Milling"
  },
  {
    value: "Done",
    label: "Done"
  },
  {
    value: "Out for Delivery",
    label: "Out for Delivery"
  },
  {
    value: "Scan Rejected",
    label: "Scan Rejected"
  }
  // {
  //   value: "—",
  //   label: "—"
  // }
];


/* =========================================================
   DELIVERY STATUS OPTIONS
========================================================= */

const deliveryOptions: OptionType[] = [
  { value: "", label: "All" },

  {
    value: "Cancelled",
    label: "Cancelled"
  },
  {
    value: "Assigned",
    label: "Assigned"
  },
  {
    value: "Ready for Dispatch",
    label: "Ready for Dispatch"
  },
  {
    value: "Out for Delivery",
    label: "Out for Delivery"
  },
  {
    value: "Done",
    label: "Done"
  }
];


/* =========================================================
   STATUS STYLE
========================================================= */

const getStatusStyle = (status: string) => {

  switch (status?.toLowerCase()) {

    case "needs attention":
      return {
        border: "1px solid #E35D6A",
        background: "#F8D7DA",
        color: "#000"
      };

    case "awaiting response":
      return {
        background: "#f97316",
        color: "#fff"
      };

    case "scan rejected":
    case "milling hub rejected":
      return {
        background: "#991b1b",
        color: "#fff"
      };

    case "design delay":
    case "milling overdue":
      return {
        background: "#b45309",
        color: "#fff"
      };

    case "on time":
      return {
        border: "1px solid #dedada",
        background: "#fff",
        color: "#000"
      };

    case "start milling":
      return {
        background: "#2563eb",
        color: "#fff"
      };

    case "waiting for design":
      return {
        background: "#f59e0b",
        color: "#000"
      };

    case "in milling":
      return {
        background: "#ffcd39",
        color: "#000"
      };

    case "done":
    case "completed":
      return {
        background: "#16a34a",
        color: "#fff"
      };

    case "cancelled":
      return {
        background: "#dc3545",
        color: "#fff"
      };

    case "to be accepted":
      return {
        background: "#0d6efd",
        color: "#fff"
      };

    case "acceptance overdue":
      return {
        background: "#dc3545",
        color: "#fff"
      };

    default:
      return {
        background: "#6b7280",
        color: "#fff"
      };
  }
};


/* =========================================================
   COMPONENT
========================================================= */

const OrderSearchPage: React.FC = () => {

  /* =======================================================
     FILTER STATES
  ======================================================= */

  const [designerStatus, setDesignerStatus] =
    useState<OptionType | null>(null);

  const [millingStatus, setMillingStatus] =
    useState<OptionType | null>(null);

  const [deliveryStatus, setDeliveryStatus] =
    useState<OptionType | null>(null);


  /* =======================================================
     RADIO BUTTON STATE

     full   = Full Service
     design = Design Service
  ======================================================= */

  const [orderView, setOrderView] =
    useState<"full" | "design">("full");


  /* =======================================================
     DATA STATES
  ======================================================= */

  const [data, setData] = useState<OrderRow[]>([]);

  const [loading, setLoading] =
    useState<boolean>(false);


  /* =======================================================
     SEARCH API
  ======================================================= */

  const handleSearch = async (): Promise<void> => {

    setLoading(true);

    try {

      const res = await apiAxios.post<ApiResponse>(
        `${API_BASE}/Central/search-cases`,
        {
          designerStatus:
            designerStatus?.value || null,

          millingStatus:
            millingStatus?.value || null,

          deliveryStatus:
            deliveryStatus?.value || null
        }
      );


      console.log(
        "Search Cases Response:",
        res.data
      );


      if (res.data?.isSuccess) {

        const responseData =
          res.data.dataOne || [];

        setData(responseData);

      } else {

        setData([]);

      }

    } catch (err) {

      console.error(
        "Search Error:",
        err
      );

      setData([]);

    } finally {

      setLoading(false);

    }
  };


  /* =======================================================
     PAGE LOAD
     
     Page open hote hi API call
     All statuses null rahenge.
  ======================================================= */

  useEffect(() => {

    handleSearch();

  }, []);


  /* =======================================================
     FILTER DATA ACCORDING TO RADIO BUTTON
     
     IMPORTANT:
     API dobara call nahi hogi.

     Full Service:
        IsDesignService = false / 0

     Design Service:
        IsDesignService = true / 1
  ======================================================= */

  const displayedData = useMemo(() => {

    return data.filter((row: any) => {

      const isDesignService =
        row.isDesignService === true ||
        row.isDesignService === 1 ||
        row.isDesignService === "1";


      if (orderView === "design") {

        return isDesignService;

      }

      return !isDesignService;

    });

  }, [data, orderView]);




  const columns: TableColumn<OrderRow>[] =
    useMemo(() => {

      const baseColumns: TableColumn<OrderRow>[] = [

        /* -----------------------------------------------
           ORDER ID
        ------------------------------------------------ */

        {
          name: "Order ID",


          selector: row =>
            row.orderID || "--",

          sortable: true
        },


      ...(orderView === "full"
  ? [
      {
        name: "Patient",
     
        selector: (row: OrderRow) => row.patientName || "--",
        sortable: true
      }
    ]
  : []),

        {
          name: "Designer",

          sortable: true,

     

          cell: row => (

            <span
              title={row.designerStatus || "--"}
            >
              {row.designerStatus || "--"}
            </span>

          )
        }

      ];
      if (orderView === "full") {

        baseColumns.push(

          /* ---------------------------------------------
             MILLING
          ---------------------------------------------- */

          {
            name: "Milling",

         

            sortable: true,

            cell: row => (

              <span
                title={row.millingStatus || "--"}
              >
                {row.millingStatus || "--"}
              </span>

            )
          },


          /* ---------------------------------------------
             DELIVERY
          ---------------------------------------------- */

          {
            name: "Delivery",

            width: "220px",

            sortable: true,

            cell: row => (

              <span
                title={row.deliveryStatus || "--"}
              >
                {row.deliveryStatus || "--"}
              </span>

            )
          }

        );

      }


      /* -----------------------------------------------
         MANAGER
      ------------------------------------------------ */

      baseColumns.push({

        name: "Manager",

        width: "180px",

        cell: row => (

          <span
            style={{
              ...getStatusStyle(
                row.managerState || ""
              ),

              padding: "4px 8px",

              borderRadius: "5px",

              fontSize: "13px",

              width: "120px",

              display: "inline-block",

              textAlign: "center"
            }}
          >

            {row.managerState || "--"}

          </span>

        )

      });


      return baseColumns;

    }, [orderView]);


  /* =======================================================
     CLEAR FILTERS
  ======================================================= */

  const handleClear = () => {

    setDesignerStatus(null);

    setMillingStatus(null);

    setDeliveryStatus(null);

  };


  /* =======================================================
     UI
  ======================================================= */

  return (

    <div className="container">

      {/* =================================================
          PAGE TITLE
      ================================================= */}

      <h5 className="mb-4 order-search-panel">
        Order Search Panel
      </h5>


      {/* =================================================
          SEARCH FILTER CARD
      ================================================= */}

      <div className="premium-card mt-2">

        {/* ===============================================
            RADIO BUTTONS
        ================================================ */}

        <div
          className="mb-4 d-flex gap-4"
          style={{
            alignItems: "center"
          }}
        >

          {/* FULL SERVICE */}

          <label
            style={{
              cursor: "pointer",
              fontWeight:
                orderView === "full"
                  ? 600
                  : 400
            }}
          >

            <input
              type="radio"

              name="orderView"

              checked={
                orderView === "full"
              }

              onChange={() =>
                setOrderView("full")
              }

              style={{
                marginRight: "6px"
              }}
            />

            Full Service

          </label>


          {/* DESIGN SERVICE */}

          <label
            style={{
              cursor: "pointer",
              fontWeight:
                orderView === "design"
                  ? 600
                  : 400
            }}
          >

            <input
              type="radio"

              name="orderView"

              checked={
                orderView === "design"
              }

              onChange={() =>
                setOrderView("design")
              }

              style={{
                marginRight: "6px"
              }}
            />

            Design Service

          </label>

        </div>


        <div className="row g-3 align-items-end">

          {/* ---------------------------------------------
              DESIGNER STATUS
          ---------------------------------------------- */}

          <div className="col-md-4">

            <label className="form-label">

              Designer Status

            </label>

        <Select
  className="status-select"
  classNamePrefix="status-select"
  options={designerOptions}
  value={designerStatus}
  onChange={(val) => setDesignerStatus(val)}
  placeholder="Select Designer Status"
  isClearable
  menuPortalTarget={document.body}
  menuPosition="fixed"
/>

          </div>


          {/* ---------------------------------------------
              MILLING STATUS

              Design Service me hide
          ---------------------------------------------- */}

          {orderView === "full" && (

            <div className="col-md-4">

              <label className="form-label">

                Milling Status

              </label>

              <Select
  className="status-select"
  classNamePrefix="status-select"
  options={millingOptions}
  value={millingStatus}
  onChange={(val) => setMillingStatus(val)}
  placeholder="Select Milling Status"
  isClearable
  menuPortalTarget={document.body}
  menuPosition="fixed"
/>

            </div>

          )}


          {/* ---------------------------------------------
              DELIVERY STATUS

              Design Service me hide
          ---------------------------------------------- */}

          {orderView === "full" && (

            <div className="col-md-4">

              <label className="form-label">

                Delivery Status

              </label>

              <Select
  className="status-select"
  classNamePrefix="status-select"
  options={deliveryOptions}
  value={deliveryStatus}
  onChange={(val) => setDeliveryStatus(val)}
  placeholder="Select Delivery Status"
  isClearable
  menuPortalTarget={document.body}
  menuPosition="fixed"
/>
            </div>

          )}


          {/* ---------------------------------------------
              SEARCH BUTTON
          ---------------------------------------------- */}

          <div className="col-md-4 mt-3">

            <button
              className="btn btn-primary"

              onClick={handleSearch}

              disabled={loading}
            >

              {loading
                ? "Searching..."
                : "Search"}

            </button>


            {/* CLEAR */}

            <button
              type="button"

              className="btn btn-secondary ms-2"

              onClick={handleClear}
            >

              Clear

            </button>

          </div>

        </div>

      </div>


      {/* =================================================
          RESULT TABLE
      ================================================== */}

      <div className="premium-card mt-5">

        {/* Result count */}

        <div
          className="mb-3 d-flex justify-content-between"
        >

          <div>

            <strong>

              {orderView === "full"
                ? "Full Service Orders"
                : "Design Service Orders"}

            </strong>

          </div>


          <div className="text-muted">

            {displayedData.length} Orders

          </div>

        </div>


        <DataTable

          columns={columns}

          data={displayedData}

          progressPending={loading}

          pagination

          highlightOnHover

          striped

          responsive

          persistTableHead

        />

      </div>

    </div>

  );

};

export default OrderSearchPage;
